// Captured local authority, distinct from renderer selection and cloud policy.
export const offlineRunPlan = run => {
  if (run?.origin === 'local_desktop' || run?.is_offline_draft === true) {
    return { expected_plan_revision: run.plan_revision ?? 0 };
  }
  const proposal = run?.offline_proposal;
  return { expected_proposal: proposal ? {
    id: proposal.id, proposal_revision: proposal.proposal_revision, review_revision: proposal.review_revision,
  } : null };
};

export const proposalPlan = proposal => ({ expected_proposal: {
  id: proposal.id, proposal_revision: proposal.proposal_revision, review_revision: proposal.review_revision,
} });

export const withRunPlan = (config, plan) => ({ ...config, runPlan: plan });
export const staleRunPlan = error => error?.response?.status === 409
  && error.response.data?.detail?.code === 'stale_plan';

export const replayPlan = (id, revision, name, date, orderIds, userId) => ({
  local_draft_run_id: id, plan_revision: revision, name: name.trim(), date,
  order_ids: [...orderIds], user_id: userId || null,
});

export const acceptsReplayPlan = (run, plan) => {
  const receipt = run?.replay_acceptance;
  const accepted = receipt?.plan;
  return receipt?.schema_version === 1 && receipt.run_id === run.id && typeof run.id === 'string'
    && ['created', 'already_replayed'].includes(run.offline_replay_result)
    && accepted?.local_draft_run_id === plan.local_draft_run_id
    && accepted?.plan_revision === plan.plan_revision && accepted?.name === plan.name
    && accepted?.date === plan.date && accepted?.user_id === plan.user_id
    && Array.isArray(accepted.order_ids) && JSON.stringify(accepted.order_ids) === JSON.stringify(plan.order_ids);
};

export const replayMessage = run => run?.offline_replay_result === 'already_replayed'
  ? 'This plan was accepted online earlier. Its local review is now recorded.'
  : 'Offline plan accepted online and recorded locally';
